/**
 * @fileoverview AnalyticsReporter provides client-side endpoints for our
 * analytics service. See the Kaggle.Services.Analytics project for
 * documentation and server-side code.
 *
 * @deprecated Do not introduce new usages of this module. One-off client event
 * logging has been moved to logger.ts, but we still rely on this for:
 * - some web-old legacy uses
 * - pageview logging
 * - general click logging
 */ function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var __generator = this && this.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
import { getCurrentPage } from "@kaggle/core";
import { usersClient } from "../../generated/users";
import { logWebpackBundlePerformanceMetrics } from "../PerformanceMetrics";
import * as protos from "./ClientProtos/ClientAnalyticsProtos";
import { logIsRecentlyViewedLink } from "./helpers";
function ignoreAnalyticsCalls() {
    var win = window;
    return process.env.NODE_ENV === "development" || typeof win.useKaggleAnalytics === "undefined" || !win.useKaggleAnalytics;
}
var AnalyticsToken = function AnalyticsToken(value) {
    "use strict";
    _classCallCheck(this, AnalyticsToken);
    this.value = value;
    this.refreshTime = new Date().getTime();
};
function isAnalyticsTokenValid(token) {
    if (!token.value) {
        return false;
    }
    var secondsSinceLastToken = (new Date().getTime() - token.refreshTime) / 1000;
    // Default token lifetime is 15 minutes
    var tokenLifetimeSeconds = 15 * 60 - 10;
    return secondsSinceLastToken < tokenLifetimeSeconds;
}
// Prepare to store the time-limited token provided by the server.
var currentToken;
// temporary hack to work around user provider refactor - eventually we should refactor this whole file
// https://b.corp.google.com/issues/258286424
var currentUserId;
// Guard against multiple calls to initialize.
var initializeCalled = false;
// Prepare to assign a UUID to this single pageview, to assist grouping events in analysis.
var pageviewId = "";
var postedFinalEvents = false;
// Retry initialize a few times if it fails
var initializeTryCounter = 0;
// initialize adds event listeners, prepares to send analytics events in batches every 10s, and records a pageview event.
export function initialize() {
    if (ignoreAnalyticsCalls()) {
        return;
    }
    // Guard against multiple calls to this function, to avoid leaky handlers being created.
    if (initializeCalled) {
        throw new Error("Analytics module already initialized.");
    }
    // Improve readability of timeouts.
    var seconds = 1000;
    // Fetch and save the token.
    Promise.all([
        usersClient.usersService.getCurrentUser({
            includeGroups: false,
            includeLogins: false
        }),
        usersClient.accountService.generateAnalyticsToken({}), 
    ]).then(function(param) {
        var _param = _slicedToArray(param, 2), getCurrentUserResponse = _param[0], generateAnalyticsTokenResponse = _param[1];
        initializeCalled = true;
        saveToken(generateAnalyticsTokenResponse.token);
        var _id;
        saveCurrentUserId((_id = getCurrentUserResponse.id) !== null && _id !== void 0 ? _id : 0);
        // While the user is browsing the page, send events in regular batches.
        window.setInterval(postPendingEvents, 10 * seconds);
        // Add global event handlers/reporters.
        document.addEventListener("click", handleClick, true);
        installErrorEventListener();
        // When the user navigates away, send any pending events immediately.
        window.addEventListener("pagehide", function() {
            reportEvent("general", "unload");
            postedFinalEvents = true;
            postPendingEvents(true);
        });
    }).catch(function(_err) {
        if (initializeTryCounter < 3) {
            initializeTryCounter++;
            initialize();
        }
    });
}
export function recordPageView() {
    // Initialize the pageview UUID, which only persists until this page is
    // unloaded.
    pageviewId = generateUUID();
    logIsRecentlyViewedLink();
    reportEvent("general", "pageview");
    reportOnPerformance();
}
// reportEvent is the main exposed function from this module. It prepares to record the analytics
// data passed in by the caller, with the addition of common fields such as the current URL. The data
// will be sent to the analytics service in a batch.
export function reportEvent(eventCategory, eventType, data) {
    if (ignoreAnalyticsCalls()) {
        return;
    }
    var evt = protos.kaggle.analytics.ClientAnalyticsEvent.create({
        eventCategory: eventCategory,
        eventType: eventType,
        eventTime: new Date().toISOString(),
        eventDataJson: data ? JSON.stringify(data) : "",
        eventPage: getCurrentPage().pageType
    });
    // Add the event to the module-level global array holding pending events.
    enqueueEvent(evt, pageviewId);
}
/**
 * A version of reportEvent that is meant to be called during the window unload event
 * It ensures that reportEvent will get posted regardless of whether AnalyticsReporter
 * already received its own unload event.
 */ export function reportEventDuringUnload(eventCategory, eventType, data) {
    reportEvent(eventCategory, eventType, data);
    if (postedFinalEvents) {
        postPendingEvents(true);
    }
}
// handleClick is a generic click handler. It records the type, id, and CSS class of the event target node,
// and all its parents. In the case of an <a> tag it also records the outgoing url.
function handleClick(ev) {
    var target = ev.target;
    // A cast to HTMLElement is necessary because, in general, not all JS event targets are DOM elements.
    var elementDescription = getElementHierarchyDescription(target);
    var targetHref = "";
    if (target.nodeName === "A") {
        targetHref = target.href;
    }
    reportEvent("general", "click", {
        eventTarget: elementDescription,
        targetUrl: targetHref
    });
}
// installErrorEventListener encapsulates the unusual logic needed for error event handling.
function installErrorEventListener() {
    // The "error" event behaves unusually, and addEventListener is less reliable -- https://stackoverflow.com/q/37933733
    var existingHandler = window.onerror;
    window.onerror = function(message, source, lineno, colno, error) {
        // Type narrowing required since message is string | Event.
        if (typeof message === "string") {
            // Don't pollute logs with CORS errors, because we can't get any useful info out of them.
            if (message && message.toLowerCase().indexOf("script error") >= 0) {
                // This handles a gotcha that occurs while testing AnalyticsReporter locally; with a non-uglified WebPack build,
                // all local sources are given the CORS treatment, so don't swallow JS errors on the console.
                if (process.env.NODE_ENV === "development") {
                    return false;
                }
                // Most browsers will interpret a `true` return value as "Stop further processing".
                return true;
            }
            // Don't pollute logs with errors thrown by browser extensions, which have non-HTTP
            // protocols (e.g. chrome-extension:// moz-extension://).
            if (!source || !source.trim().toLowerCase().startsWith("http")) {
                return true;
            }
            reportJSError(message, source, lineno !== null && lineno !== void 0 ? lineno : 0, colno !== null && colno !== void 0 ? colno : 0, error !== null && error !== void 0 ? error : new Error(message));
        }
        return existingHandler && existingHandler(message, source, lineno, colno, error);
    };
}
// reportJSError reports JavaScript errors to our analyics endpoint.
function reportJSError(message, source, lineno, colno, error) {
    // Prepare to include some details from the `error` property. It should be an Error object, but let's not make too many cross-browser assumptions.
    var errorInfo = "";
    if (error && error.stack) {
        // Error.prototype.stack is the most verbose, but MDN calls it "non-standard" and warns of "large incompatibilities" across users.
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/Stack
        errorInfo = error.stack;
    } else {
        // Fall back to Error.toString() -- or even Object.toString() -- if the stacktrace is not available.
        errorInfo = error.toString();
    }
    reportEvent("telemetry", "error", {
        message: message,
        source: source,
        lineno: lineno,
        colno: colno,
        error: errorInfo
    });
}
// getElementHierarchyDescription returns a string with a concatenated list of DOM node identifiers, in
// the format "${TYPE}#{id}${class} > ...." ordered from lowest node to root.
function getElementHierarchyDescription(childNode) {
    var result = getElementDescription(childNode);
    var currentElement = childNode.parentElement;
    while(currentElement && currentElement.nodeName !== "BODY"){
        result += " < " + getElementDescription(currentElement);
        currentElement = currentElement.parentElement;
    }
    return result;
}
function getElementDescription(element) {
    // Elements may optionally provide a more specific id for click logging via
    // the data-click-log-id attribute.
    var clickLogId = element.dataset.clickLogId;
    return "".concat(element.nodeName).concat(clickLogId ? "[data-click-log-id=".concat(clickLogId, "]") : "", "#").concat(element.id, ".").concat(element.className);
}
// getOrCreateSessionId returns a UUID identifying a user's session on Kaggle. Sessions last
// for 1 month, with the session ID stored in a cookie. This enables us to track the behavior
// of non-logged-in users.
function getOrCreateSessionId() {
    var existingResult = getSessionCookie();
    if (existingResult) {
        return existingResult;
    }
    var newResult = generateUUID();
    setSessionCookie(newResult);
    return newResult;
}
// getSessionCookie returns the session ID if it is present in the user's browser cookies, and
// null otherwise.
function getSessionCookie() {
    // Split the document.cookie and search by key name
    var cookieLocation = ("; " + document.cookie).split("; ka_sessionid=");
    if (cookieLocation.length === 2) {
        var ref;
        var ref1;
        // ka_sessionid value exists in the current cookie
        return (ref1 = (ref = cookieLocation.pop()) === null || ref === void 0 ? void 0 : ref.split(";").shift()) !== null && ref1 !== void 0 ? ref1 : "";
    }
    return null;
}
// setSessionCookie saves a session ID to the user's browser cookie.
function setSessionCookie(value) {
    // Following go/cookie-guidelines, we use 1-month expiry for this cookie without an explicit opt-in.
    var msPerSecond = 1000;
    var msPerMinute = 60 * msPerSecond;
    var msPerHour = 60 * msPerMinute;
    var msPerDay = 24 * msPerHour;
    var msPerMonth = 30.4 * msPerDay;
    var expiryDate = new Date();
    expiryDate.setTime(expiryDate.getTime() + msPerMonth);
    document.cookie = "ka_sessionid=".concat(value, "; expires=").concat(expiryDate.toUTCString(), "; path=/");
}
// generateUUID makes a generic 40-digit UUID.
function generateUUID() {
    var randDigits;
    if (window.crypto) {
        // If the Web Cryptography API is available, use it (to reduce the chance of
        // collisions in session ids).
        var randArray = new Uint8Array(20);
        window.crypto.getRandomValues(randArray);
        randDigits = Array.from(randArray);
    } else {
        randDigits = Array.from(Array(20).keys()).map(function(_i) {
            return Math.floor(Math.random() * 32);
        });
    }
    return randDigits// Convert the random bytes to hex...
    .map(function(d) {
        return d.toString(16);
    })// ...then join them into a single string, left-padding them with 0 when needed.
    .reduce(function(previousValue, currentValue) {
        return previousValue + (currentValue.length === 1 ? "0" + currentValue : currentValue);
    }, "");
}
function enqueueEvent(event, // eslint-disable-next-line no-shadow,@typescript-eslint/no-shadow
pageviewId) {
    var ref;
    if (!eventsToPost.has(pageviewId)) {
        eventsToPost.set(pageviewId, []);
    }
    (ref = eventsToPost.get(pageviewId)) === null || ref === void 0 ? void 0 : ref.push(event);
}
// eventsToPost is a module-level global that contains a batch of analytics events to be sent.
var eventsToPost = new Map();
// failedRequests tallies up the HTTP errors we've encountered, to avoid repeatedly trying if (e.g.) the
// server is sending 302s to a user with an authentication issue.
var failedRequests = 0;
// This is shared with "sdk/src/analytics/logger.ts".
var ANALYTICS_TOKEN_KEY = "analyticsToken";
var CURRENT_USER_ID_TOKEN_KEY = "currentUserIdToken";
function getTokenFromLocalStorage() {
    try {
        var tokenJson = localStorage.getItem(ANALYTICS_TOKEN_KEY);
        if (!tokenJson) {
            return null;
        }
        var storedToken = JSON.parse(tokenJson);
        if (!isAnalyticsTokenValid(storedToken)) {
            return null;
        }
        return storedToken;
    } catch (e) {
        return null;
    }
}
function getCurrentUserIdFromLocalStorage() {
    try {
        var tokenJson = localStorage.getItem(CURRENT_USER_ID_TOKEN_KEY);
        if (!tokenJson) {
            return null;
        }
        var storedToken = JSON.parse(tokenJson);
        return storedToken;
    } catch (e) {
        return null;
    }
}
function refreshToken() {
    return _refreshToken.apply(this, arguments);
}
function _refreshToken() {
    _refreshToken = _asyncToGenerator(function() {
        var storedToken, response;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    storedToken = getTokenFromLocalStorage();
                    if (!storedToken) return [
                        3,
                        1
                    ];
                    currentToken = storedToken;
                    return [
                        3,
                        3
                    ];
                case 1:
                    return [
                        4,
                        usersClient.accountService.generateAnalyticsToken({})
                    ];
                case 2:
                    response = _state.sent();
                    saveToken(response.token);
                    _state.label = 3;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _refreshToken.apply(this, arguments);
}
function saveToken(newToken) {
    currentToken = new AnalyticsToken(newToken);
    try {
        localStorage.setItem(ANALYTICS_TOKEN_KEY, JSON.stringify(currentToken));
    } catch (e) {
    // no-op
    }
}
function saveCurrentUserId(newUserId) {
    currentUserId = newUserId;
    try {
        localStorage.setItem(CURRENT_USER_ID_TOKEN_KEY, JSON.stringify(newUserId));
    } catch (e) {
    // no-op
    }
}
// postPendingEvents sends the contents of eventsToPost to the analytics service. If the page
// is unloading, it uses the Beacon API, so that the request continues after the page is closed.
// TODO(jamiehall): update to use the async/await style.
export function postPendingEvents() {
    var pageIsUnloading = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    if (failedRequests > 20) {
        return;
    }
    Array.from(eventsToPost.keys()).forEach(function(pvId) {
        var ref;
        var postedEvents = (ref = eventsToPost.get(pvId)) === null || ref === void 0 ? void 0 : ref.slice();
        if (!postedEvents) {
            return;
        }
        if (!isAnalyticsTokenValid(currentToken)) {
            // See if there is a newer token in localStorage.
            currentToken = getTokenFromLocalStorage() || currentToken;
        }
        currentUserId = getCurrentUserIdFromLocalStorage() || currentUserId;
        eventsToPost.delete(pvId);
        var batch = protos.kaggle.analytics.SaveClientAnalyticsRequest.create({
            url: document.location.pathname,
            userId: currentUserId,
            session: getOrCreateSessionId(),
            timeZoneOffsetMinutes: new Date().getTimezoneOffset(),
            referrer: document.referrer,
            token: currentToken.value,
            windowWidthPixels: window.innerWidth,
            windowHeightPixels: window.innerHeight,
            screenWidthPixels: window.screen.width,
            screenHeightPixels: window.screen.height,
            events: postedEvents,
            pageview: pvId,
            urlQueryString: window.location.search
        });
        var payload = protos.kaggle.analytics.SaveClientAnalyticsRequest.encode(batch).finish();
        var destinationUrl = "https://analytics.kaggle.io/record-events";
        // If we're about to lose the window, and the Beacon API is available, use sendBeacon and ignore any result.
        if (pageIsUnloading && navigator.sendBeacon) {
            navigator.sendBeacon(destinationUrl, payload);
            return;
        }
        // In normal cases, use the standard Fetch API.
        fetch(destinationUrl, {
            method: "POST",
            body: payload
        }).then(function(response) {
            if (response.ok) {
                return;
            }
            if (pageIsUnloading) {
                // In the rare case that the browser has honored a fetch() request during unload, don't keep the user waiting any longer.
                return;
            }
            // The endpoint will return an HTTP401 if the provided token was not valid.
            if (response.status === 401) {
                // Token is stale, so try requesting another.
                refreshToken().then(function() {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        // Add the events back to the queue to be sent.
                        for(var _iterator = postedEvents[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var event = _step.value;
                            enqueueEvent(event, pvId);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }).catch(function() {
                    failedRequests++;
                });
            } else {
                failedRequests++;
            }
        }).catch(function() {
            failedRequests++;
        });
    });
}
// reportOnPerformance uses the Resource Timing API to analyze request/response timing for the initial pageload.
function reportOnPerformance() {
    if (!performance || !performance.getEntriesByType || !performance.clearResourceTimings) {
        return;
    }
    logWebpackBundlePerformanceMetrics();
    // Save some bandwidth by summarizing the timing into just a few numbers.
    performance.getEntriesByType("resource").map(function(a) {
        return {
            asset: a.name,
            startupTime: a.domainLookupStart ? a.domainLookupStart - a.startTime : 0,
            dnsTime: a.domainLookupEnd ? a.domainLookupEnd - a.domainLookupStart : 0,
            tcpTime: a.connectEnd - a.connectStart,
            requestTime: a.responseStart ? a.responseStart - (a.requestStart || a.fetchStart) : 0,
            responseTime: a.responseEnd - (a.requestStart || a.fetchStart),
            totalTime: a.responseEnd - a.startTime
        };
    }).forEach(function(summary) {
        return reportEvent("telemetry", "resources", summary);
    });
    performance.clearResourceTimings();
}
